module.exports = __webpack_public_path__ + "ebe21f5669e9037132dfb822645a1119.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/backgrounds/6.jpg
// module id = 169
// module chunks = 0